import { render, staticRenderFns } from "./completions.vue?vue&type=template&id=c4892976&scoped=true"
import script from "./completions.vue?vue&type=script&lang=js"
export * from "./completions.vue?vue&type=script&lang=js"
import style0 from "./completions.vue?vue&type=style&index=0&id=c4892976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4892976",
  null
  
)

export default component.exports